import axios from 'axios'
import store from '@/store'

export default {
  getProjects () {
    const token = localStorage.getItem('access_token')
    return new Promise((resolve, reject) => {
      axios.get('/api/projects', {
        headers: {
          Authorization: 'Bearer' + token
        }
      })
        .then((res) => {
          store.dispatch('projects/setProjects', res.data)
          resolve(res.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getJiraProjects () {
    const token = localStorage.getItem('access_token')
    return new Promise((resolve, reject) => {
      axios.get('/api/jiraProjects', {
        headers: {
          Authorization: 'Bearer' + token
        }
      })
        .then((res) => {
          store.dispatch('projects/setJiraProjects', res.data)
          resolve(res.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  create (formData) {
    const token = localStorage.getItem('access_token')
    return new Promise((resolve, reject) => {
      axios.post('/api/create-project', formData, {
        headers: {
          Authorization: 'Bearer' + token
        }
      }).then(({ data }) => {
        resolve(data)
      }, error => {
        reject(error)
      })
    })
  },
  update (id, formData) {
    const token = localStorage.getItem('access_token')
    return new Promise((resolve, reject) => {
      axios.post(`/api/update-project/${id}`, formData, {
        headers: {
          Authorization: 'Bearer' + token
        }
      }).then(({ data }) => {
        resolve(data)
      }, error => {
        reject(error)
      })
    })
  },
  remove (id) {
    const token = localStorage.getItem('access_token')
    return new Promise((resolve, reject) => {
      axios.post(
        '/api/remove-project', { project_id: id }, {
          headers: {
            Authorization: 'Bearer' + token
          }
        }).then(({ data }) => {
        resolve(data)
      }, error => {
        reject(error)
      })
    })
  }
}
